import {
  BonusResponse,
  BonusResult,
  BonusRound,
  ExtraGain,
  PaytableItem,
  RoundButton,
} from '@cgs/data-access';
import {
  BonusButtonDto,
  BonusExtraGainsDto,
  BonusInfoDto,
  BonusResultDto,
  BonusRoundDto,
  BonusRoundPaytableItemDto,
} from '../../models';

export function mapExtraGain(gains: BonusExtraGainsDto): ExtraGain {
  const extra = new ExtraGain();

  extra.type = gains.type || '';
  extra.value = gains.value || 0;

  return extra;
}

export function mapBonusButton(bonusButton: BonusButtonDto): RoundButton {
  const response = new RoundButton();

  response.index = bonusButton.index || 0;
  response.type = bonusButton.type;
  response.value = bonusButton.value || 0;
  response.totalValue = bonusButton.totalValue || 0;
  response.routingIndex = bonusButton.routingIndex || 0;
  response.view = bonusButton.view;
  response.extraValues = bonusButton.extraValues?.map(mapExtraGain);

  return response;
}

export function mapBonusRoundPaytableItem(paytableItem: BonusRoundPaytableItemDto): PaytableItem {
  const response = new PaytableItem();
  response.index = paytableItem.index ?? 0;
  response.type = paytableItem.type ?? '';
  response.value = paytableItem.value ?? 0;
  response.totalValue = paytableItem.totalValue ?? 0;
  response.extraValues = paytableItem.extraValues.map(mapExtraGain);

  return response;
}

export function mapBonusRound(bonusRound: BonusRoundDto): BonusRound {
  const response = new BonusRound();
  response.attemps = bonusRound.attempts || 0;
  response.attempsUsed = bonusRound.attemptsUsed || 0;
  response.notSelectedButtons = (bonusRound.notSelectedButtons || []).map(mapBonusButton);
  response.roundNumber = bonusRound.roundNumber || 0;
  response.roundType = bonusRound.roundType;
  response.selectedButtons = (bonusRound.selectedButtons || []).map(mapBonusButton);
  response.serverSelectedButtons = (bonusRound.serverSelectedButtons || []).map(mapBonusButton);
  response.paytable = (bonusRound.paytable || []).map(mapBonusRoundPaytableItem);

  return response;
}

export function mapBonusResult(result: BonusResultDto): BonusResult {
  const response = new BonusResult();
  response.bonusWin = 0;
  response.totalWin = 0;
  response.additionWin = 0;
  response.multiplier = result.multiplier ?? 1;
  response.bet = result.bet || 0;
  response.lines = result.lines || 0;
  response.winName = '';
  response.betCalculation = result.betCalculation || '';
  response.winLines = null;
  return response;
}

export function bonusInfoMapper(bonusInfo: BonusInfoDto): BonusResponse {
  const response = new BonusResponse();

  response.bonusFinished = bonusInfo.bonusFinished || false;
  response.bonusStarted = bonusInfo.bonusStarted || false;
  response.currentRound = bonusInfo.currentRound ? mapBonusRound(bonusInfo.currentRound) : null;
  response.previousRounds = (bonusInfo.previousRounds || []).map(mapBonusRound);
  response.nextRound = bonusInfo.nextRound ? mapBonusRound(bonusInfo.nextRound) : null;
  response.result = bonusInfo.result ? mapBonusResult(bonusInfo.result) : null;
  response.type = bonusInfo.type || '';
  response.bonusType = bonusInfo.bonusType || '';

  return response;
}
